export default __webpack_public_path__ + "sounds/framework/yayOOO_R.a008d733.mp3?a008d733";